import React, { useState } from "react";
import { Box, Typography, Slider, Button, Card, CardContent, Grid, Stack } from "@mui/material";
import BenefitLogo from './Assets/Bronze.png';
import ProgressCard from "./Components/ProgressCard";

const dummyData = {
  message: "My Benefit Details fetched successfully",
  error: false,
  data: {
    club_progress_details: {
      id: 1,
      title: "Gold Club",
      logo: `${BenefitLogo}`,
      subtitle: "Current Level",
      description: {
        display_name: "25 to 51 MT",
        color: "#f49d3f",
      },
      slider_info: {
        club_min_value: 25,
        club_max_value: 51,
        current_value: 30,
        uom: "Ton",
        header_text: "Progress to Platinum Club",
        footer_text: "100 Ton Required for next club",
      },
    },
    clubLevels : [
        { name: "Blue Club", min: 0, max: 340 },
        { name: "Bronze Club", min: 341, max: 500},
        { name: "Silver Club", min: 501, max: 1000 },
        { name: "Gold Club", min: 1000, max: 2000},
        { name: "Platinum Club", min: 2000, max: 4000 },
        { name: "Diamond Club", min: 4000, max: Infinity },
    ],
    volume: {
      min: 0,
      max: 5000,
      step: 1,
      uom: "Ton",
    },
    association_period: {
        min: 0,
        max: 100,
        step: 1,
        uom: "Years",
    },
  },
};

const GapCalculator = () => {
    const { club_progress_details, clubLevels, volume, association_period } = dummyData.data;
    const [businessVolume, setBusinessVolume] = useState(75);
    const [associationPeriod, setAssociationPeriod] = useState(50);
    const [estimatedGap, setEstimatedGap] = useState(null);

    const handleCalculate = () => {
        const estimatedValue = businessVolume * associationPeriod * 10000;
        setEstimatedGap(estimatedValue);
    };

    const getCurrentClub = (volume) => {
        return clubLevels.find((club) => volume >= club.min && volume <= club.max);
    };

    const currentClub = getCurrentClub(businessVolume);

    return (
        <Box sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>HUMBEE Benefits</Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12}>
            <Card sx={{ p: 2, boxShadow: 'none', border: '1px dashed #0000001a' }}>
                <ProgressCard ProgressDetails={club_progress_details} />
            </Card>
            </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12}>
            <Card sx={{ p: 2, boxShadow: 'none', border: '1px dashed #0000001a' }}>
                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>Gap Calculator</Typography>
                <Typography variant="body1" sx={{ mb: 5 }}>Estimate your future GAP accumulation</Typography>

                <Typography sx={{ mb: 2 }}>Quarterly average monthly Business Volume in TON</Typography>
                <Grid container sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <Stack spacing={2} direction="row" sx={{ alignItems: 'center', mb: 1, width: '100%', justifyContent: 'space-between' }}>
                    <Typography variant="body2" sx={{ width: '5%' }}>{`${volume.min} ${volume.uom}`}</Typography>
                    <Slider 
                    value={businessVolume} 
                    min={volume.min} 
                    max={volume.max} 
                    step={volume.step}
                    onChange={(e, val) => setBusinessVolume(val)}
                    valueLabelDisplay="auto"
                    sx={{ height: 8, borderRadius: 5, flex: 1, mb: 1 }}
                    />
                    <Typography variant="body2" sx={{ width: '5%', textAlign:'end' }}>{`${volume.max} ${volume.uom}`}</Typography>
                </Stack>
                </Grid>

                <Typography sx={{ mb: 2 }}>Based on Above the club will be</Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        {clubLevels.map((club) => (
                            <Button 
                                disabled={businessVolume < club.min || businessVolume > club.max}
                                variant="outlined"
                                key={club.name}
                                sx={{ mr: 2 , p:2, fontWeight: 'bold'}}
                            >
                                {club.name}
                            </Button>
                        ))}
                    </Grid>
                </Grid>

                <Typography sx={{ mb: 2, mt: 3 }}>Select Period for Association with HUMBEE</Typography>
                <Grid container alignItems="center">
                <Stack spacing={2} direction="row" sx={{ alignItems: 'center', mb: 1, width: '100%', justifyContent: 'space-between' }}>
                    <Typography variant="body2" sx={{ width: '4%' }}>{`${association_period.min} ${association_period.uom}`}</Typography>
                    <Slider 
                        value={associationPeriod} 
                        min={association_period.min} 
                        max={association_period.max} 
                        step={1} 
                        onChange={(e, val) => setAssociationPeriod(val)}
                        valueLabelDisplay="auto"
                        sx={{ height: 8, borderRadius: 5, flex: 1, mb: 1 }}
                    />
                    <Typography variant="body2" sx={{ width: '5%', textAlign:'end' }}>{`${association_period.max} ${association_period.uom}`}</Typography>
                </Stack>
                </Grid>
            </Card>
            </Grid>
        </Grid>
        <Button fullWidth variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleCalculate}>
            Calculate Estimated GAP
        </Button>
        {estimatedGap !== null && (
            <Card variant="outlined" sx={{ mt: 2, p: 2, textAlign: "center" }}>
            <Typography variant="subtitle1">Estimated Quarterly GAP Accumulation in {currentClub?.name}</Typography>
            <Typography variant="h5" color="primary">₹ {estimatedGap.toLocaleString("en-IN")}</Typography>
            </Card>
        )}
        </Box>
    );
};

export default GapCalculator;
